/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-useless-computed-key */
import SimpleCrypto from 'simple-crypto-js';

const { REACT_APP_CRIPTO_KEY } = process.env;

const simpleCripto = new SimpleCrypto(REACT_APP_CRIPTO_KEY);

const userAuth = {
  token: localStorage.getItem(String('@Fretapp/token')) || '',
  id: localStorage.getItem(String('@Fretapp/id')) || '',
  type: localStorage.getItem(String('@Fretapp/type')) || '',
};

export const getToken = () => {
  // userAuth.token = String(JSON.parse(userAuth.token));
  if (userAuth.token !== '') {
    return simpleCripto.decrypt(JSON.parse(userAuth.token));
  }
  return '';
};

export const getIdLoggedUser = () => {
  if (userAuth.id !== '') {
    return simpleCripto.decrypt(JSON.parse(userAuth.id));
  }
  return '';
};

export const getTypeUser = () => {
  if (userAuth.type !== '') {
    return simpleCripto.decrypt(JSON.parse(userAuth.type));
  }
  return '';
};
